import React, { Component } from 'react';
import { Card, CardBody  } from 'reactstrap';
import { metadataService , LeadService } from "../../_services";
import { SlButton } from '../editors';


export class AcknowledgeReferral extends Component {
    constructor(props) {
        super(props);
        this.handleAcknowledgement = this.handleAcknowledgement.bind(this);
    }
    handleAcknowledgement(){
        LeadService.acknowledgeReferrals().then(r =>{ 
            if(r.status <= 1){
                this.props.acknowledgeReferrals(); 
            }})
    }


    render(){
        return (
            <Card>
                <CardBody>
                    
                        <div className="text-center"> 
                            {metadataService.getMessage("ReferralMessage1")}
                        </div>
                        <div className="text-center"> 
                            {metadataService.getMessage("ReferralMessage2")}
                        </div>
                        <div className="text-center"> 
                        <SlButton name="OK" onClick={this.handleAcknowledgement}/>
                        </div>
                    
                </CardBody>
            </Card>
        )};
}